const RECENTLY_VIEWED_KEY = 'previouslyViewedProducts';
const MAX_PRODUCTS = 6;

class LyleRecentlyViewed extends HTMLElement {
  connectedCallback() {
    try {
      const price = this.dataset.price ? Number(this.dataset.price) : 0;
      const compareAtPrice = this.dataset.compareAtPrice ? Number(this.dataset.compareAtPrice) : null;

      const product = {
        id: Number(this.dataset.id),
        handle: this.dataset.handle,
        title: this.dataset.title,
        url: this.dataset.url,
        featured_image: this.dataset.featuredImage || null,
        secondary_image: this.dataset.secondaryImage || null,
        alt_image: this.dataset.altImage || null,
        price,
        compare_at_price: compareAtPrice,
      };

      const raw = localStorage.getItem(RECENTLY_VIEWED_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      const existing = Array.isArray(parsed) ? parsed : [];
      const filtered = existing.filter((p) => p.handle !== product.handle);
      filtered.push(product);
      if (filtered.length > MAX_PRODUCTS) filtered.splice(0, filtered.length - MAX_PRODUCTS);
      localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(filtered));
      document.dispatchEvent(new CustomEvent('recently-viewed:updated'));
    } catch {
      // silently skip — localStorage may be unavailable (private browsing, storage full)
    }
  }
}

if (!customElements.get('lyle-recently-viewed')) {
  customElements.define('lyle-recently-viewed', LyleRecentlyViewed);
}
